import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SectionTitle from '../SectionTitle/SectionTitle';
import Vator from '../../images/testimonial/vector.png'
import Img1 from '../../images/product/red injera.jpg'
import Img2 from '../../images/product/phillip-flores-xOZ6RWwI8Ng-unsplash.jpg'
import Img3 from '../../images/product/meat-board (1).jpg'
import Img4 from '../../images/product/knife-4841892_640.jpg'
import Img5 from '../../images/product/mitad.jpg'

const services = [
    {
        id: '01',
        img: Img1,
        title: 'Injera & Baked Goods',
        description: "Authentic Ethiopian injera and freshly baked goods made with traditional recipes.",
        sub: "Traditional & Delicious"
    },
    {
        id: '02',
        img: Img2,
        title: 'Money Transfer',
        description: "Fast, secure money transfer services to send funds anywhere.",
        sub: "Reliable & Convenient"
    },
    {
        id: '03',
        img: Img3,
        title: 'Catering Services',
        description: "Professional catering featuring authentic Ethiopian cuisine.",
        sub: "For All Occasions"
    },
    {
        id: '04',
        img: Img4,
        title: 'Spices & Ingredients',
        description: "Premium Ethiopian spices and cooking ingredients.",
        sub: "Authentic Flavors"
    },
    {
        id: '05',
        img: Img5,
        title: 'Household Needs',
        description: "Essential household items and traditional products.",
        sub: "Quality Essentials"
    }
]

const Testimonial = (props) => {
    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="orico-testimonial-area section-padding">
            {/* <div className="t-shape"><img src={Vator} alt="" /></div> */}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <SectionTitle subtitle={'OUR SERVICES'} title={'What We Offer'} />
                    </div>
                </div>
                <div className="orico-testimonial-wrap">
                    <div className="testimonial-slider">
                        <Slider {...settings}>
                            {services.map((service, item) => (
                                <div className="orico-testimonial-item" key={item}>
                                    <div className="orico-testimonial-img">
                                        <img src={service.img} alt={service.title} />
                                    </div>
                                    <div className="orico-testimonial-content">
                                        <p>{service.description}</p>
                                        <h2>{service.title}</h2>
                                        <span>{service.sub}</span>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Testimonial;